function enumChannelType(typeChannelString) {
  const typeList = {
    1: 'email',
    2: 'sms',
  }
  return typeList[typeChannelString] || null
}

function enumPlanPeriod(value) {
  const typeList = {
    1: 'MONTHLY',
    2: 'QUARTERLY',
    3: 'YEARLY',
    4: 'NON_RENEWABLE',
  }
  return typeList[value] || null
}

function organizationType(type) {
  const typeList = {
    1: 'sendit',
    2: 'client',
  }
  return typeList[type] || null
}

function planType(type) {
  const typeList = {
    1: 'FREE',
    2: 'STANDARD',
    3: 'CUSTOM',
    4: 'CORPORATE',
    5: 'PAY_AS_YOU_GO'
  }
  return typeList[type] || null
}
function organizationBalanceConfigType(type) {
  const typeList = {
    1: 'NO_OWN_BALANCE',
    2: 'OWN_BALANCE_DEPENDENT',
    3: 'OWN_BALANCE_INDEPENDENT',
  }
  return typeList[type] || null
}

function historyBalanceTypeName(type) {
  const typeList = {
    1: 'PURCHASE',
    2: 'GRANT',
    3: 'TAKE',
    4: 'CAMPAIGN',
    5: 'TRANSACTIONAL',
  }
  return typeList[type] || null
}

function featuresType(type) {
  const typeList = {
    1: 'USER_ACCESS',
    2: 'SUB_ORGANIZATIONS',
    3: 'CHANNEL_EMAIL',
    4: 'CHANNEL_SMS',
    5: 'AUDIENCE_IMPORT',
    6: 'AUDIENCE_SEGMENTS',
    7: 'AUDIENCE_RECIPIENT_PROFILE',
    8: 'CAMPAIGN_EDITOR',
    9: 'CAMPAIGN_STATISTICS',
    10: 'CAMPAIGN_TESTS',
    11: 'TEMPLATES',
    12: 'AUTOMATION_WORKFLOWS',
    13: 'LANDING_PAGES',
    14: 'FORMS',
    15: 'SMART_AUDIENCES',
    16: 'ADVANCED_REPORTING',
    17: 'CLIENT_SUPPORT',
    18: 'CUSTOMER_SUCCESS_MANAGER',
    19: 'DEDICATED_IP',
    20: 'SUPPORT_247',
    21: 'BALANCE',
  }
  return typeList[type] || null
}

export { enumChannelType, enumPlanPeriod, organizationType, planType, organizationBalanceConfigType, historyBalanceTypeName, featuresType }
